<template>
  <div>
    <div class="card" v-if="active_page === 'OperationOverviews'">
      <div class="title">
        <span>运营数据概览-{{ r_type }}</span>
        <div
          style="
            margin-left: auto;
            margin-right: 0;
            font-size: 16px;
            color: var(--primary-color);
            cursor: pointer;
            font-weight: normal;
            margin-right: -18px;
          "
          @click="active_page = 'Operation'">
          &gt;&gt;进入单指标详情
        </div>
      </div>
      <div class="CH_Card_content" style="margin-top: 20px">
        <CCascader
          ref="type_r"
          :options="type_r_list"
          :default="r_type"
          @CCascader_select_val="fnCCascader_type_r"
          :checkStrictly="true"
          :multiple="false"
          :isDelete="false"
          :middle="true"
          takeOut="takeOut"
          :collapsetags="true"
          custWidth="150px"
          >选择类别
        </CCascader>
        <CCascader
          :key="r_type"
          v-if="code_list.length"
          ref="CCascader2_chart1"
          style="margin-left: 20px"
          @CCascader_select_val="fnSelect_codes"
          :default="code"
          :options="code_list"
          :checkStrictly="false"
          :multiple="true"
          :isDelete="false"
          :wide="true"
          :collapsetags="true">
          选择对比REITs
        </CCascader>
        <div class="flex items-center" style="margin-left: 20px">
          <span style="font-size: 14px; color: var(--chart_title)">显示类型: </span>
          <CButtons
            style="margin-left: 6px"
            :dButtons1="select_2"
            :dButtons1_current="select_2_default"
            @Cbtns_sep="select2Change" />
        </div>
        <CCascader
          v-if="period_list.length"
          ref="CCascader2_chart2"
          style="margin-left: 20px"
          @CCascader_select_val="fnSelect_period"
          :default="period"
          :options="period_list"
          :checkStrictly="false"
          :multiple="false"
          :isDelete="false"
          :wide="true"
          custWidth="100px"
          :collapsetags="true">
          当前财报期
        </CCascader>
        <div style="margin-right: 0; margin-left: auto">
          <Download
            v-show="!loading_tabel"
            :downloadImg="false"
            :excel_info="excel_info_1"
            echartRefName="null" />
        </div>
      </div>
      <div
        class="CH_Card_content"
        :key="r_type"
        :style="`--brc:${currentTheme === 'dark' ? 'rgb(76, 77, 93)' : 'rgb(220, 221, 222)'}`">
        <el-table
          :class="['table1', { 'municipal-table': r_type === '市政生态' }]"
          style="flex: none; width: 100%"
          :height="table_height"
          :data="table_data"
          :header-cell-style="tableStyle"
          :header-cell-class-name="headerClass"
          v-loading="loading_tabel"
          @header-click="handleTableClickHead"
          @cell-click="handleCellClick"
          :row-key="getOperationRowKey"
          :tree-props="{ children: 'childrens' }"
          :default-expand-all="r_type === '市政生态'"
          element-loading-text="数据量巨大，正在计算中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 1)">
          <el-table-column
            v-for="item in table_head"
            :key="item.label"
            :align="item.children ? 'center' : 'left'"
            :sortable="!!item.sort"
            :label="item.label"
            :prop="item.prop + '.value'"
            :min-width="item.children ? '' : getLabelWidth(item.label, item.sort, item.tooltip)"
            :fixed="item.label === '代码' || item.label === '名称'"
            :class-name="item.label === '代码' || item.label === '名称' ? 'cursor-pointer' : ''">
            <template #header v-if="item.tooltip">
              {{ item.label }}
              <el-tooltip effect="dark" placement="right">
                <template #content>
                  <div style="max-width: 50vw" v-html="item.tooltip"></div>
                </template>
                <i
                  class="el-icon-question"
                  style="font-size: 16px; margin-left: 0px; color: rgb(64, 158, 255)"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope" v-if="!item.children">
              {{ fmtValue(scope.row[item.prop].value, scope.row[item.prop].unit) }}
              <el-tooltip v-if="scope.row[item.prop].tooltip" effect="dark" placement="right">
                <template #content>
                  <div style="max-width: 50vw" v-html="scope.row[item.prop].tooltip"></div>
                </template>
                <i
                  class="el-icon-question"
                  style="font-size: 16px; margin-left: 0px; color: rgb(64, 158, 255)"></i>
              </el-tooltip>
            </template>
            <template v-if="item.children">
              <el-table-column
                v-for="item2 in item.children"
                :key="item.label + item2.label"
                :sortable="!!item2.sort"
                :label="item2.label"
                :align="isMetricColumn(item2) ? 'left' : 'right'"
                :class-name="isMetricColumn(item2) ? 'metric-column' : 'value-column'"
                :prop="item.prop + '.' + item2.prop + '.value'"
                :min-width="item2.children ? '' : getChildColumnWidth(item2)">
                <template #header v-if="item2.tooltip">
                  {{ item2.label }}
                  <el-tooltip effect="dark" placement="right">
                    <template #content>
                      <div style="max-width: 50vw" v-html="item2.tooltip"></div>
                    </template>
                    <i
                      class="el-icon-question"
                      style="font-size: 16px; margin-left: 0px; color: rgb(64, 158, 255)"></i>
                  </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <div
                    :style="{
                      color: table_color_map[scope.row[item.prop][item2.prop].color],
                    }">
                    {{
                      fmtValue(
                        scope.row[item.prop][item2.prop].value,
                        scope.row[item.prop][item2.prop].unit
                      )
                    }}
                    <div v-if="scope.row[item.prop][item2.prop].lfl_value">
                      （
                      {{
                        fmtValue(
                          scope.row[item.prop][item2.prop].lfl_value,
                          scope.row[item.prop][item2.prop].unit
                        )
                      }}同资产口径）
                    </div>
                    <span v-if="scope.row[item.prop][item2.prop].suffix">
                      {{ scope.row[item.prop][item2.prop].suffix }}
                    </span>
                    <el-tooltip
                      effect="dark"
                      placement="right"
                      v-if="scope.row[item.prop][item2.prop].tooltip">
                      <template #content>
                        <div
                          style="max-width: 50vw"
                          v-html="scope.row[item.prop][item2.prop].tooltip"></div>
                      </template>
                      <i
                        class="el-icon-question"
                        style="font-size: 16px; margin-left: 0px; color: rgb(64, 158, 255)"></i>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="CH_Card_content"
        :style="r_type === '市政生态' ? { minHeight: '700px' } : {}">
        <div
          class="download-wrap"
          style="
            padding-top: 0px;
            position: absolute;
            right: 120px;
            top: 0;
            padding-top: 0px;
            z-index: 55;
          ">
          <Download v-show="!loading_chart" :excel_info="excel_info_2" echartRefName="chart_1804" />
        </div>
        <div
          v-show="!loading_chart"
          class="iconfont icon-fangda"
          style="top: 4px; right: 80px"
          @click="show_chart_dialog = true"></div>
        <div
          :style="{
            width: '100%',
            height: r_type === '市政生态' ? '680px' : '350px',
          }"
          ref="chart_1804"
          v-loading="loading_chart"
          element-loading-text="数据量巨大，正在计算中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 1)"></div>
      </div>
      <div class="CH_Card_content">
        <div
          class="border-card"
          v-loading="loading_tag_summary"
          element-loading-text="数据量巨大，正在计算中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 1)">
          <div>运营异动提示：（内容为从{{ select_2_default }}报中摘取）</div>
          <div class="content">
            <div class="item" v-for="item in tag_summary_data" :key="item.tag">
              <div class="tag-name" :style="{ '--icl': item.color }">
                {{ item.tag }}
              </div>
              <div class="text">
                <div class="text-item" v-for="t in item.content" :key="t.name">
                  <div style="margin-bottom: 4px">{{ t.name }}</div>
                  <div class="text-li" v-for="(text, index) in t.text" :key="index">
                    {{ text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChartDialog :show.sync="show_chart_dialog" :echart_options="chart_dialog_options" />
    </div>
    <Operation
      v-if="active_page === 'Operation'"
      :g_r_type="r_type"
      :select_tag.sync="select_tag"
      @changePage="changePage"
      ref="Operation" />
  </div>
</template>

<script>
import CCascader from '@/components/Basic/CCascader';
import CButtons from '@/components/Basic/CButtons_separate.vue';
import Download from '@/components/Basic/Download.vue';
import ChartDialog from '@/components/Basic/ChartDialog.vue';
import CDialog from '@/components/Basic/CDialog.vue';

import Operation from './Operation.vue';
import { fnReturnTableStyle } from '@/utils/util';
import { debounce, number2Pct, numberFix2N, numberFix2 } from '@/utils';

const countStringLength = (str) => {
  let len = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    if (charCode >= 0x4e00 && charCode <= 0x9fa5) {
      len += 1;
    } else {
      len += 0.65;
    }
  }
  return len + 0.85;
};

export default {
  name: 'OperationOverviews',
  components: { CCascader, CButtons, Download, ChartDialog, Operation, CDialog },
  data() {
    return {
      table_height: 450,
      active_page: 'OperationOverviews',
      loading_tabel: true,
      table_data: [],
      table_head: [],
      table_data_hasChildren: false,

      loading_chart: true,
      chart_tags: [],
      chart_data: [],
      chart_panels: [],

      loading_tag_summary: true,
      tag_summary_data: [],
      table_color_map: Object.freeze({
        '-1': '#00b4ff',
        1: '#FF7043',
      }),
      select_tag: '',
      //----------------------------------------
      chart_dialog_options: {},
      show_chart_dialog: false,
      excel_info_1: Object.freeze({
        overviewName: '底层资产-运营数据-多指标概览-表格',
        excel_data: [],
        json_fields: {},
      }),
      excel_info_2: Object.freeze({
        overviewName: '底层资产-运营数据-多指标概览-图表',
        excel_data: [],
        json_fields: {},
      }),
      ROOTFONTFIZE: 0,
      r_type: '市政生态',
      type_r_list: Object.freeze([
        {
          value: '产权类',
          label: '产权类',
          disabled: true,
          children: [
            {
              value: '物流仓储',
              label: '物流仓储',
            },
            {
              value: '产业园',
              label: '产业园',
            },
            {
              value: '租赁住房',
              label: '租赁住房',
            },
            {
              value: '消费',
              label: '消费',
            },
            {
              value: '数据中心',
              label: '数据中心',
            },
          ],
        },
        {
          value: '经营权类',
          label: '经营权类',
          disabled: true,
          children: [
            {
              value: '市政生态',
              label: '市政生态',
            },
            {
              value: '能源',
              label: '能源',
            },
            {
              value: '交通设施',
              label: '交通设施',
            },
          ],
        },
        /*  {
          value: '公募REITs',
          label: '公募REITs',
          disabled: true,
        }, */
      ]),
      code: [],
      code_list: [],
      select_2: Object.freeze(['季', '月']),
      select_2_default: '季',
      period: '',
      period_list: [],
    };
  },
  computed: {
    tableStyle() {
      const val = this.$store.state.theme === 'dark';
      return () => fnReturnTableStyle(val);
    },
    qsStr() {
      const r_type = this.r_type;
      const period_type = this.select_2_default === '季' ? 'Q' : 'M';
      const qs = new URLSearchParams({
        category_2: r_type,
        period_type,
        current_period: this.period,
      });
      this.code.forEach((item) => qs.append('codes', item));
      const qsStr = qs.toString();
      return qsStr;
    },
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    active_page(n) {
      if (n === 'OperationOverviews') {
        setTimeout(() => {
          this.renderChart();
        }, 200);
      }
    },
    currentTheme(newVal, oldVal) {
      setTimeout(() => {
        this.renderChart();
      }, 0);
    },
    qsStr(val) {
      const r_type = this.r_type;
      const period_type = this.select_2_default === '季' ? 'Q' : 'M';
      if (val !== `category_2=${r_type}&period_type=${period_type}&current_period=`) {
        this.reload();
      }
    },
  },
  methods: {
    getOperationRowKey(row) {
      const cellValue = (cell) => (cell && cell.value != null ? String(cell.value) : '');
      return [cellValue(row.code), cellValue(row.name), cellValue(row.asset_name)].join('|');
    },
    fmtValue(v, t) {
      if (['', null, undefined].includes(v)) return '';
      if (typeof v === 'number') {
        const t_map = {
          pct: number2Pct,
        };
        if (t_map[t]) {
          return t_map[t](v);
        } else {
          const isInteger = Number.isInteger(v);
          return numberFix2(v, isInteger ? 0 : 2);
        }
      }
      return v;
    },
    handleCellClick(row, { label }) {
      if (label === '代码' || label === '名称') {
        let arr = [row.name.value, row.code.value];
        this.$eventBus.$emit('skipPage', arr);
      }
    },
    changePage(name) {
      this.active_page = name;
      this.echart_instance && this.echart_instance.dispose();
      this.echart_instance = null;
    },
    handleTableDownload() {
      const head = this.table_head;
      let data = this.table_data || [];
      if (this.table_data_hasChildren) {
        data = data.reduce((p, c) => {
          const { childrens = [], ...row } = c;
          p.push(row, ...childrens);
          return p;
        }, []);
      }
      if (!head.length || !data.length) return;
      const json_fields = head.reduce((p, c) => {
        if (c.children) {
          c.children.forEach((item) => {
            p[c.label + '-' + item.label] = item.prop;
          });
        } else {
          p[c.label] = c.prop;
        }
        return p;
      }, {});
      const keys = Object.keys(data[0]);
      const excel_data = data.map((item) => {
        return keys.reduce((p, c) => {
          const value = item[c].value;
          if (value !== undefined) {
            p[c] = value;
          } else {
            const k = Object.keys(item[c]);
            k.forEach((key) => {
              p[key] = item[c][key].value;
            });
          }
          return p;
        }, {});
      });
      this.excel_info_1 = Object.freeze({
        overviewName: `${this.excel_info_1.overviewName}(${this.r_type})`,
        excel_data,
        json_fields,
      });
    },
    handleChartTableDownload() {
      const data = this.chart_data;
      if (!data.length) return;
      const json_fields = {
        名称: 'name',
        code: 'reit_code',
      };
      data[0].data.forEach(({ name, tag }) => {
        json_fields[name + tag + this.chart_info.bar.cn_name] = name + tag + 'bar';
        json_fields[name + tag + this.chart_info.line.cn_name] = name + tag + 'line';
      });
      const excel_data = data.map(({ name, reit_code, data }) => {
        const ot = data.reduce((p, c) => {
          p[c.name + c.tag + 'bar'] = c.value.bar;
          p[c.name + c.tag + 'line'] = c.value.line;
          return p;
        }, {});
        return {
          name,
          reit_code,
          ...ot,
        };
      });
      this.excel_info_2 = Object.freeze({
        overviewName: `${this.excel_info_2.overviewName}(${this.r_type})`,
        excel_data,
        json_fields,
      });
    },
    headerClass({ column }) {
      if (column.children) return 'cursor-pointer';
      return '';
    },
    handleTableClickHead({ property, children }) {
      if (!children) return;
      const reg = /\.value$/;
      const prop = property.replace(reg, '');
      this.select_tag = prop;
      this.changePage('Operation');
    },
    getLabelWidth(label, hasSort, hasTooltip) {
      const tmp = hasSort ? 20 : 0;
      const tmp2 = hasTooltip ? 12 : 0;
      const arr_w = this.table_data_hasChildren ? 30 : 0;
      if (typeof label === 'string') {
        if (label === '代码')
          return this.r_type === '市政生态' ? 100 : 125 + tmp + tmp2 + arr_w;
        if (label === '名称') return this.r_type === '市政生态' ? 125 : 160;
        if (label === '资产' || label === '资产名称')
          return this.r_type === '市政生态' ? 150 : 160;
        if (label === '指标/单位') return this.r_type === '市政生态' ? 160 : 210;
        return countStringLength(label) * 20 + tmp + tmp2;
      }
      if (Array.isArray(label)) {
        const l = label.reduce((p, c) => {
          return p + countStringLength(c);
        }, 0);
        return l * 20 + tmp + tmp2;
      }
      return 0;
    },
    isMetricColumn(column) {
      return this.r_type === '市政生态' && /_metric$/.test(column.prop || '');
    },
    getChildColumnWidth(column) {
      if (this.r_type !== '市政生态') {
        return this.getLabelWidth(column.label, column.sort, column.tooltip);
      }
      if (this.isMetricColumn(column)) return 190;
      if (/_crr$|_yoy$/.test(column.prop || '')) return 88;
      return 76;
    },
    reload: debounce(function () {
      this.getTableData();
      this.getChartData();
      this.getTagSummaryData();
    }, 500),
    getTagOrderFromData(data) {
      const tagSet = new Set();
      data.forEach((company) => {
        company.data.forEach((item) => {
          if (item && item.tag) tagSet.add(item.tag);
        });
      });
      const tags = Array.from(tagSet);

      const quarterOrder = ['Q1', 'Q2', 'Q3', 'Q4'];
      const halfOrder = ['H1', 'H2'];
      const annualOrder = ['A'];

      if (tags.length && tags.every((t) => quarterOrder.includes(t))) {
        return quarterOrder.filter((t) => tags.includes(t));
      }
      if (tags.length && tags.every((t) => halfOrder.includes(t))) {
        return halfOrder.filter((t) => tags.includes(t));
      }
      if (tags.length && tags.every((t) => annualOrder.includes(t))) {
        return annualOrder.filter((t) => tags.includes(t));
      }

      return tags.sort();
    },
    getYearOrderFromData(data) {
      const yearSet = new Set();
      data.forEach((company) => {
        company.data.forEach((item) => {
          if (item && item.name) yearSet.add(item.name);
        });
      });
      const years = Array.from(yearSet);
      return years.sort((a, b) => {
        const na = Number(a);
        const nb = Number(b);
        if (!isNaN(na) && !isNaN(nb)) return na - nb;
        return String(a).localeCompare(String(b));
      });
    },
    renderChart() {
      if (!this.chart_data.length && !this.chart_panels.length) {
        return;
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.chart_1804);
      }
      this.echart_instance.clear();

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;

      if (this.r_type === '市政生态') {
        this.renderMunicipalChart(OPTIONDATA);
        return;
      }

      // 非市政生态切回时，确保 echart canvas 高度恢复 350px
      this.echart_instance.resize({ height: 350 });

      const rawData = this.chart_data;

      const tagOrder = this.getTagOrderFromData(rawData);
      const isAnnual = tagOrder.length === 1 && tagOrder[0] === 'A';
      const keys = isAnnual ? this.getYearOrderFromData(rawData) : tagOrder;

      let categoryData = [];
      let lineData = [];

      let seriesDataByKey = {};
      keys.forEach((k) => {
        seriesDataByKey[k] = [];
      });

      rawData.forEach((company, cIdx) => {
        company.data.forEach((item) => {
          categoryData.push(`${company.name}|${item.name}|${item.tag}`);

          const barValue = item.value ? item.value.bar : null;
          const lineValue = item.value ? item.value.line : null;

          keys.forEach((k) => {
            const match = isAnnual ? item.name === k : item.tag === k;
            seriesDataByKey[k].push(match ? barValue : '-');
          });

          lineData.push(lineValue);
        });

        if (cIdx < rawData.length - 1) {
          categoryData.push(`SPACER|${cIdx}`);
          keys.forEach((k) => {
            seriesDataByKey[k].push('-');
          });
          lineData.push('-');
        }
      });

      let companyLabelMap = {};
      let yearLabelMap = {};

      let companyRanges = {};
      let yearRanges = {};

      categoryData.forEach((cat, idx) => {
        if (cat.includes('SPACER')) return;
        let parts = cat.split('|');
        let cName = parts[0];
        let yName = parts[1];
        let yKey = cName + '|' + yName;

        if (!companyRanges[cName]) companyRanges[cName] = { start: idx, end: idx };
        else companyRanges[cName].end = idx;

        if (!yearRanges[yKey]) yearRanges[yKey] = { start: idx, end: idx };
        else yearRanges[yKey].end = idx;
      });

      Object.keys(companyRanges).forEach((name) => {
        let range = companyRanges[name];
        let mid = Math.floor((range.start + range.end) / 2);
        companyLabelMap[mid] = name;
      });

      Object.keys(yearRanges).forEach((key) => {
        let range = yearRanges[key];
        let pos = range.start;
        yearLabelMap[pos] = key.split('|')[1];
      });

      const fix_num_map = {
        pct: number2Pct,
      };
      const fixLineNum = fix_num_map[this.chart_info.line.unit];

      const options = {
        toolbox: {
          // 工具箱按钮
          right: '0%',
          top: -5,
          itemSize: 18,
          iconStyle: {
            borderColor: OPTIONDATA.toolbox.iconStyle.borderColor,
          },
          feature: {
            dataZoom: {}, // 区域缩放
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: (params) => {
            let result = '';
            let nameRaw = params[0].axisValue;
            if (nameRaw.includes('SPACER')) return '';

            let parts = nameRaw.split('|');
            result += `${parts[0]} ${parts[1]} ${parts[2]}<br/>`;

            params.forEach((param) => {
              if (param.value !== '-' && param.value !== undefined) {
                if (fixLineNum) {
                  param.value = fixLineNum(param.value);
                }
                result += `${param.marker} ${param.seriesName}: ${param.value}<br/>`;
              }
            });
            return result;
          },
        },
        legend: {
          data: [...this.chart_tags.map((item) => item.name), this.chart_info.line.cn_name],
          top: 0,
          left: 0,
          textStyle: {
            color: OPTIONDATA.legend.textStyle.color,
            fontSize: this.ROOTFONTFIZE * (14 / 144),
          },
          itemWidth: 12,
          itemHeight: 12,
        },
        grid: {
          top: this.ROOTFONTFIZE * (80 / 144),
          left: this.ROOTFONTFIZE * (30 / 144),
          right: this.ROOTFONTFIZE * (30 / 144),
          bottom: this.ROOTFONTFIZE * (0 / 144),
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: categoryData,
            axisLabel: {
              color: OPTIONDATA.xAxis.axisLabel.color,
              interval: 0,
              formatter: function (value, index) {
                return yearLabelMap[index] || '';
              },
              fontSize: this.ROOTFONTFIZE * (10 / 144),
            },
            axisTick: { show: false },
            axisLine: { show: false },
          },
          {
            type: 'category',
            data: categoryData,
            position: 'bottom',
            offset: 20, // Move it down
            axisLabel: {
              color: OPTIONDATA.xAxis.axisLabel.color,
              interval: 0,
              rotate: 30,
              formatter: function (value, index) {
                return companyLabelMap[index] || '';
              },
              fontSize: this.ROOTFONTFIZE * (10 / 144),
            },
            axisTick: { show: false },
            axisLine: { show: false },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: this.chart_info.bar.cn_name,
            nameTextStyle: { color: OPTIONDATA.legend.textStyle.color },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
              show: true,
              color: OPTIONDATA.yAxis.axisLabel.color,
            },
            splitLine: OPTIONDATA.yAxis.splitLine,
          },
          {
            type: 'value',
            name: this.chart_info.line.cn_name,
            nameTextStyle: { color: OPTIONDATA.legend.textStyle.color },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
              show: true,
              color: OPTIONDATA.yAxis.axisLabel.color,
              formatter: (value) => {
                if (fixLineNum) return fixLineNum(value);
                return value;
              },
            },
            splitLine: OPTIONDATA.yAxis.splitLine,
          },
        ],
        series: (() => {
          const colorMap = this.chart_tags.reduce((p, c) => {
            p[c.name] = c.color;
            return p;
          }, {});

          const barSeries = keys.map((k, idx) => {
            return {
              name: k,
              type: 'bar',
              stack: 'total',
              data: seriesDataByKey[k],
              itemStyle: {
                color: colorMap[k],
              },
              barWidth: '60%',
            };
          });

          const lineSeries = {
            name: this.chart_info.line.cn_name,
            type: 'line',
            yAxisIndex: 1,
            data: lineData,
            itemStyle: { color: '#FF7043' },
            symbol: 'circle',
            symbolSize: 6,
            connectNulls: false,
          };

          return [...barSeries, lineSeries];
        })(),
      };
      this.chart_dialog_options = Object.freeze(options);
      this.echart_instance.setOption(options);
      this.echart_instance.resize();
    },
    renderMunicipalChart(OPTIONDATA) {
      const companies = [];
      this.chart_panels.slice(0, 4).forEach((company) => {
        if (company.business_groups && company.business_groups.length) {
          company.business_groups.forEach((group) => {
            const available = (group.metrics || []).filter((metric) =>
              (metric.data || []).some((item) => item.value !== null && item.value !== undefined)
            );
            if (!available.length) return;
            const leftMetric = available[0];
            const rightMetric =
              available.find((metric, index) => index > 0 && /单价|结算/.test(metric.cn_name)) ||
              available[1];
            companies.push({
              name: `${company.name}｜${group.name}`,
              left: leftMetric,
              right: rightMetric || { cn_name: '', unit: '', data: [] },
              data: (leftMetric.data || []).map((item, index) => ({
                name: item.name,
                tag: item.tag,
                left: item.value,
                right:
                  rightMetric && rightMetric.data && rightMetric.data[index]
                    ? rightMetric.data[index].value
                    : null,
              })),
            });
          });
        } else {
          companies.push(company);
        }
      });
      const panelCount = companies.length;
      const columnCount = Math.min(4, panelCount);
      const rowHeight = 310;
      const firstRowTop = 42;
      const gap = 2;
      const panelWidth = (100 - gap * (columnCount - 1)) / columnCount;
      const textColor = OPTIONDATA.legend.textStyle.color;
      const axisColor = OPTIONDATA.xAxis.axisLabel.color;
      const grids = [];
      const titles = [];
      const xAxis = [];
      const yAxis = [];
      const series = [];
      const legends = [];
      const historicalColors = ['#858A92', '#969BA3', '#A8ADB4', '#BABEC4', '#CDD0D5'];
      const currentBarColor = '#5ae8ed';
      const lineColor = '#FF7043';

      companies.forEach((company, index) => {
        const column = index % columnCount;
        const row = Math.floor(index / columnCount);
        const left = column * (panelWidth + gap);
        const axisIndex = index * 2;
        const periods = company.data.map((item) => `${item.name}${item.tag}`);
        grids.push({
          left: `${left + 0.7}%`,
          width: `${panelWidth - 1.4}%`,
          top: row * rowHeight + firstRowTop + 68,
          height: 180,
          containLabel: true,
        });
        titles.push({
          text: company.name,
          left: `${left + panelWidth / 2}%`,
          top: row * rowHeight + firstRowTop,
          textAlign: 'center',
          textStyle: { color: textColor, fontSize: 13, fontWeight: 'normal' },
        });
        legends.push({
          data: [company.left.cn_name, company.right.cn_name],
          left: `${left + panelWidth / 2}%`,
          top: row * rowHeight + firstRowTop + 27,
          orient: 'horizontal',
          itemWidth: 10,
          itemHeight: 10,
          textStyle: { color: textColor, fontSize: 10 },
        });
        xAxis.push({
          type: 'category',
          gridIndex: index,
          data: periods,
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { color: axisColor, fontSize: 10, rotate: 35, interval: 0 },
        });
        yAxis.push(
          {
            type: 'value',
            gridIndex: index,
            name: company.left.cn_name,
            nameTextStyle: { color: textColor, fontSize: 10 },
            axisLabel: { color: axisColor, fontSize: 10, formatter: (value) => numberFix2(value) },
            splitLine: OPTIONDATA.yAxis.splitLine,
          },
          {
            type: 'value',
            gridIndex: index,
            name: company.right.cn_name,
            nameTextStyle: { color: textColor, fontSize: 10 },
            axisLabel: {
              color: axisColor,
              fontSize: 10,
              formatter: (value) =>
                company.right.unit === 'pct' ? number2Pct(value) : numberFix2(value),
            },
            splitLine: { show: false },
          }
        );
        series.push(
          {
            name: company.left.cn_name,
            type: 'bar',
            xAxisIndex: index,
            yAxisIndex: axisIndex,
            data: company.data.map((item, dataIndex) => ({
              value: item.left,
              itemStyle: {
                color:
                  dataIndex === company.data.length - 1
                    ? currentBarColor
                    : historicalColors[Math.min(dataIndex, historicalColors.length - 1)],
              },
            })),
            valueUnit: company.left.unit,
            // 图例沿用最新季度的青色；历史柱由 data.itemStyle 覆盖为灰色。
            itemStyle: { color: currentBarColor },
            barMaxWidth: 22,
          },
          {
            name: company.right.cn_name,
            type: 'line',
            xAxisIndex: index,
            yAxisIndex: axisIndex + 1,
            data: company.data.map((item) => item.right),
            valueUnit: company.right.unit,
            itemStyle: { color: lineColor },
            lineStyle: { color: lineColor },
            symbol: 'circle',
            symbolSize: 5,
            connectNulls: false,
          }
        );
      });

      const options = {
        title: titles,
        grid: grids,
        xAxis,
        yAxis,
        series,
        legend: legends,
        tooltip: {
          trigger: 'axis',
          formatter: (params) => {
            if (!params || !params.length) return '';
            const lines = [params[0].axisValue];
            params.forEach((param) => {
              const item = series[param.seriesIndex] || {};
              let value = '-';
              if (param.value !== null && param.value !== undefined && param.value !== '-') {
                value = item.valueUnit === 'pct' ? number2Pct(param.value) : numberFix2(param.value);
                if (item.valueUnit && item.valueUnit !== 'pct') value += ` ${item.valueUnit}`;
              }
              lines.push(`${param.marker}${param.seriesName}: ${value}`);
            });
            return lines.join('<br/>');
          },
        },
      };
      this.chart_dialog_options = Object.freeze(options);
      this.echart_instance.setOption(options);
      // 市政生态为两排七图，必须显式同步 canvas 高度；仅修改外层 div
      // 时 ECharts 会沿用首次初始化的 350px，造成第二排覆盖第一排。
      this.echart_instance.resize({ height: 680 });
    },
    async getTagSummaryData() {
      this.loading_tag_summary = true;
      const { data } = await this.$https.get(`/api/v4/get_expressway_tag_summary?${this.qsStr}`);
      if (data.code !== 200) return this.$message.error(data.msg);
      this.tag_summary_data = Object.freeze(data.data);
      setTimeout(() => {
        this.loading_tag_summary = false;
      }, 200);
    },
    async getChartData() {
      this.loading_chart = true;
      const { data } = await this.$https.get(`/api/v4/get_expressway_chart_data?${this.qsStr}`);
      if (data.code !== 200) return this.$message.error(data.msg);
      this.chart_panels = Object.freeze(data.data.panels || []);
      this.chart_data = Object.freeze(data.data.data || []);
      this.chart_tags = Object.freeze(data.data.tags);
      this.chart_info = data.data.bar
        ? Object.freeze({ bar: data.data.bar, line: data.data.line })
        : null;
      setTimeout(() => {
        this.loading_chart = false;
        this.renderChart();
        setTimeout(() => {
          if (this.chart_info) this.handleChartTableDownload();
        }, 100);
      }, 200);
    },
    async getTableData() {
      this.loading_tabel = true;
      this.table_head = [];
      this.table_data = [];
      const api_map = {
        dft: '/api/v4/get_logistics_table_data',
        交通设施: '/api/v4/get_expressway_table_data',
      };
      const api_base = api_map[this.r_type] || api_map['dft'];
      const { data } = await this.$https.get(`${api_base}?${this.qsStr}`);
      if (data.code !== 200) return this.$message.error(data.msg);
      const normalized = this.normalizeMunicipalTable(data.data.table_head, data.data.table_data);
      this.table_data = Object.freeze(normalized.tableData);
      this.table_head = Object.freeze(normalized.tableHead);
      this.table_data_hasChildren = normalized.tableData.some((row) => !!row.childrens);
      setTimeout(() => {
        this.loading_tabel = false;
        setTimeout(() => {
          if (this.table_height !== 450) {
            this.table_height = 450;
          } else {
            this.table_height = 449;
          }
          this.handleTableDownload();
        }, 100);
      }, 200);
    },
    normalizeMunicipalTable(tableHead = [], tableData = []) {
      if (this.r_type !== '市政生态') return { tableHead, tableData };

      const metricMap = {
        '180701.SZ': {
          vol_main: '供应原水量（万立方米）',
          equip_util: '产能利用率（%）',
          avg_price: '平均原水单价（元/立方米）',
        },
        '508006.SH': {
          vol_main: '污水处理量（万立方米）',
          equip_util: '产能利用率（%）',
          avg_price: '平均水处理单价（元/立方米）',
        },
        '180801.SZ': {
          vol_main: '发电量（万千瓦时）',
          equip_util: '设备利用率（%）',
          avg_price: '平均垃圾处理单价（元/吨）',
        },
        '508087.SH': {
          vol_main: '供热面积（万平方米）',
          equip_util: '收缴率（%）',
          avg_price: '居民按面积供热价（元/平方米/供暖季）',
        },
      };
      const indicatorProps = ['vol_main', 'equip_util', 'avg_price'];
      const tableHeadWithMetric = tableHead.map((head) => {
        if (!indicatorProps.includes(head.prop) || !head.children) return head;
        if (head.children.some((child) => child.prop === `${head.prop}_metric`)) return head;
        return {
          ...head,
          children: [
            {
              label: '指标/单位',
              prop: `${head.prop}_metric`,
              sort: 0,
              tooltip: '',
              unit: '',
            },
            ...head.children,
          ],
        };
      });
      const addMetricCells = (row, parentCode = '') => {
        const code = (row.code && row.code.value) || parentCode;
        const metrics = metricMap[code] || {};
        const normalizedRow = { ...row };
        indicatorProps.forEach((prop) => {
          if (!normalizedRow[prop] || !metrics[prop]) return;
          const metricProp = `${prop}_metric`;
          if (!normalizedRow[prop][metricProp]) {
            normalizedRow[prop] = {
              ...normalizedRow[prop],
              [metricProp]: { value: metrics[prop], color: 0, tooltip: '', unit: '' },
            };
          }
        });
        if (row.childrens) {
          normalizedRow.childrens = row.childrens.map((child) => addMetricCells(child, code));
        }
        return normalizedRow;
      };
      return {
        tableHead: tableHeadWithMetric,
        tableData: tableData.map((row) => addMetricCells(row)),
      };
    },
    async getPeriodList() {
      const period = this.select_2_default === '季';
      const r_type = this.r_type;
      const api_map = {
        // 消费: '/api/v4/get_rp_period_list',
        // 租赁住房: '/api/v4/get_rp_period_list',
        // dft: '/api/v4/get_expressway_rp_period_list',
        dft: '/api/v4/get_rp_period_list',
      };
      // const api_base = api_map[r_type] || api_map.dft;
      const api_base = api_map.dft;
      const { data } = await this.$https.get(
        `${api_base}?month=${period ? 0 : 1}&quarter=${period ? 1 : 0}&category_2=${r_type}`
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      const period_list = data.data.map((item) => ({
        value: item,
        label: item,
      }));
      this.period_list = Object.freeze(period_list);
      const period_value = data.data[data.data.length - 1];
      this.period = period_value;
      if (this.$refs.CCascader2_chart2) {
        this.$refs.CCascader2_chart2.value = period_value;
      }
    },
    select2Change(val) {
      this.select_2_default = val;
      this.getPeriodList();
    },
    fnSelect_period(val) {
      this.period = val;
    },
    fnSelect_codes(val) {
      this.code = Object.freeze(val);
    },
    fnCCascader_type_r(val) {
      this.r_type = val;
      const t = '交通设施' !== val;
      if (t) {
        this.select_2 = Object.freeze(['季']);
        this.select2Change('季');
      } else {
        this.select_2 = Object.freeze(['季', '月']);
      }
      this.$nextTick(() => {
        this.get_operation_data_button();
      });
    },
    funResize() {
      this.echart_instance && this.echart_instance.resize();
      this.fnGetWidth();
    },
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
      return;
    },
    async get_operation_data_button() {
      /* const { data } = await this.$https.get(
        `/api/v2_5/get_operation_data_button?r_type=${this.r_type}`
      );
      if (data.code !== 200) return this.$message.error(data.msg);
      const CODEobj = JSON.parse(localStorage.getItem('CODEobj'));
      const codes = data.data.codes.map((item) => ({
        value: item,
        label: CODEobj[item],
      }));
      this.code_list = Object.freeze(codes);
      this.code = Object.freeze(data.data.codes);
      */

      let CODELIST = null;
      if (this.CODELIST) {
        CODELIST = this.CODELIST;
      } else {
        const _CODELIST = JSON.parse(localStorage.getItem('CODELIST'));
        this.CODELIST = _CODELIST;
        CODELIST = _CODELIST;
      }
      const r_type = this.r_type;

      this.code_list = CODELIST.reduce((p, c) => {
        if (c.reitsTypeL2 === r_type) {
          p.push({
            label: c.reitsName,
            value: c.reitCode,
          });
        }
        return p;
      }, []);
      const codes = this.code_list.map((item) => item.value);
      this.code = Object.freeze(codes);
      if (this.$refs.CCascader2_chart1) {
        this.$refs.CCascader2_chart1.value = codes;
      }

      return;
      // 旧代码

      let REITsNAME = null;
      if (this.REITsNAME) {
        REITsNAME = this.REITsNAME;
      } else {
        const _REITsNAME = JSON.parse(localStorage.getItem('REITsNAME'));
        this.REITsNAME = _REITsNAME;
        REITsNAME = _REITsNAME;
      }
      // 和上面声明冲突了
      // const r_type = this.r_type;
      let item = null;
      for (let i = 0; i < REITsNAME.length; i++) {
        const item2 = REITsNAME[i];
        item = (item2.children || []).find((item) => item.label === r_type);
        if (item) break;
      }
      // 和上面声明冲突了
      // const codes = (item.children || []).map((item) => item.value);
      this.code_list = Object.freeze(item.children || []);
      this.code = Object.freeze(codes);
      if (this.$refs.CCascader2_chart1) {
        this.$refs.CCascader2_chart1.value = codes;
      }
    },
    async handleClick() {
      if (this.page_init) return;
      await this.get_operation_data_button();
      await this.getPeriodList();
      this.page_init = true;
    },
  },
  mounted() {
    this.funResize();
    window.addEventListener('resize', this.funResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.funResize);
    this.echart_instance && this.echart_instance.dispose();
  },
};
</script>

<style scoped lang="less">
.flex {
  display: flex;
}

.items-center {
  align-items: center;
}
/deep/.cursor-pointer {
  cursor: pointer;
}

.title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 28px;
  color: var(--chart_title);
  // border-left: 5px solid rgba(21, 115, 254, 1);
  border-left: 5px solid var(--primary-color);
  padding-left: 13px;
  padding-right: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // margin-top: 15px;
}

.CH_Card_content {
  position: relative;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding: 0 calc(var(--ROOTFONTFIZE) * (20 / 144));
  .download-wrap {
    flex: none;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    padding-bottom: 10px;
  }
  /deep/.icon-fangda {
    position: absolute !important;
  }
}
.border-card {
  width: 100%;
  height: auto;
  min-height: 200px;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid var(--item_date_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  color: var(--chart_title);
  .content {
    margin-top: 20px;
    .item {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      & + .item {
        margin-top: 20px;
      }
      .tag-name {
        flex: none;
        border-radius: 3px;
        background-color: var(--icl, var(--comingIPO_bgc));
        padding: 3px 5px;
      }
      .text {
        width: 95%;
        padding: 10px;
        border-radius: 4px;
        box-sizing: border-box;
        background-color: var(--pagination_brc);
        .text-item + .text-item {
          margin-top: 20px;
        }
        .text-li {
          display: flex;
          align-items: baseline;
          &::before {
            content: '';
            flex: none;
            display: block;
            width: 8px;
            height: 8px;
            margin: 0 4px;
            border-radius: 50%;
            background-color: var(--chart_title);
          }
        }
      }
    }
  }
}

/deep/.el-table__fixed::before {
  background-color: transparent !important;
}

/* el-table start */
/* ::v-deep .el-table {
  overflow: hidden auto !important;
} */
::v-deep .table1 table,
.el-table--border,
.el-table--group {
  border: none;
}
::v-deep .el-table--border .el-table__cell {
  // border-right: none;
  border-right-color: var(--brc);
}

::v-deep .el-table__body .el-table__row .el-table__cell {
  background-color: var(--table_bgc);
  color: var(--table_color);
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  height: calc(var(--ROOTFONTFIZE) * (60 / 144));
  border-bottom: calc(var(--ROOTFONTFIZE) * (1 / 144)) solid var(--table_brc);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: var(--table_bgc_hover);
  /* background-color: var(--table_color_hover); */
  color: var(--table_color_hover);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell:hover {
  cursor: pointer;
}

::v-deep .el-table::before,
.el-table::after {
  background-color: var(--table_bgc);
}

::v-deep .el-table {
  border-bottom: none !important;
  background-color: var(--table_bgc);
}

/* 市政生态指标名称较长：指标左对齐并换行，数值列紧凑展示。 */
::v-deep .municipal-table .metric-column .cell {
  padding: 0 8px;
  white-space: normal;
  line-height: 20px;
  text-align: left;
  word-break: break-word;
}

::v-deep .municipal-table .value-column .cell {
  padding: 0 6px;
  white-space: nowrap;
}

::v-deep .municipal-table th.el-table__cell > .cell {
  padding-left: 6px;
  padding-right: 6px;
}

/* el-table end */
</style>
